module.exports = __webpack_public_path__ + "img/birdlife-neu.360ab9ed.png";